import DetailsTemplate from "./DetailsTemplate";

export default DetailsTemplate;
